import styled from 'styled-components'

export const EmptyPageContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 64px;
    min-height: 65vh;

    svg {
        color: ${({ theme }) => theme.darkColor};
    }
`